
import { getElementHeight } from "~/utils";
export default {
  props: {
    contentData: {
      type: Object,
      default: () => {},
    },
    questionFormData: {
      type: [Object, null],
      default: null,
    },
    askQuestionData: {
      type: [Object, null],
      default: null,
    },
    shipReturnData: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      activeAccordion: "",
    };
  },
  methods: {
    getElementHeight,
    setActiveAccordion(accValue) {
      if (this.activeAccordion === accValue) {
        this.activeAccordion = null;
      } else {
        this.activeAccordion = accValue;
      }
    },
  },
};
